import React from 'react';
import { PLACEHOLDER } from './constants';
import { ActiveItemStyled } from './styled';
const getItemByActiveItem = (items, activeItem, isDisabled, isRightToLeft = false, contents = false) => {
    const foundItem = items.find((item) => item.value === activeItem);
    return (React.createElement(ActiveItemStyled, { isDisabled: isDisabled, isRightToLeft: isRightToLeft, className: foundItem?.icon ? 'has-icon' : '', contents: contents },
        foundItem?.icon,
        foundItem?.label));
};
export const getActiveItemFromItems = ({ activeItem, items, isDisabled, isRightToLeft, inputPlaceholder, contents, }) => activeItem
    ? getItemByActiveItem(items, activeItem, isDisabled, isRightToLeft, contents)
    : inputPlaceholder || PLACEHOLDER;
export const getActiveFromString = (activeItem, isDisabled, inputPlaceholder, isRightToLeft = false, contents = false) => activeItem ? (React.createElement(ActiveItemStyled, { isRightToLeft: isRightToLeft, isDisabled: isDisabled, contents: contents }, activeItem)) : (inputPlaceholder || PLACEHOLDER);
